import React, {useEffect, useState} from 'react';
import {useKeycloak} from '@react-keycloak/web';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';

import {Descriptions, Divider, Drawer, message, Spin} from 'antd';
import Media from 'pages/health/Media';
import {handleError} from 'utils/MessageUtils';
import {findOrderById} from 'services/OrderService';
import {ServiceRequestStatus} from 'shared/constants/AppConst';

const OrderInfo = (props) => {
  const {keycloak} = useKeycloak();
  const intl = useIntl();

  const headers = {
    Authorization: `Bearer ${keycloak?.token}`,
    'Accept-Language': intl.locale,
  };

  const {orderId, viewing, setViewing, setReloading} = props;
  const [order, setOrder] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (viewing && orderId?.length > 0) {
      setLoading(true);
      findOrderById(headers, orderId)
        .then((res) => {
          setOrder(res.data);
          setViewing(true);
        })
        .catch((error) => handleError(message, error))
        .finally(() => setLoading(false));
    }
  }, [viewing]);

  const onClose = () => {
    setViewing(false);
    setReloading(true);
  };

  return (
    <Drawer
      title={intl.messages['common.detail']}
      width={800}
      onClose={onClose}
      visible={viewing}
      destroyOnClose={true}
      bodyStyle={{paddingBottom: 80}}>
      <Spin spinning={loading}>
        <Descriptions
          bordered
          size='middle'
          style={{paddingTop: 10}}
          column={2}>
          <Descriptions.Item label={intl.messages['order.procedure']}>
            {order?.procedure?.id} - {order?.procedure?.name}
          </Descriptions.Item>
          <Descriptions.Item label={intl.messages['order.requester']}>
            {order?.requester?.name}
          </Descriptions.Item>
          <Descriptions.Item label={intl.messages['order.performer']}>
            {order?.performer?.name}
          </Descriptions.Item>
          <Descriptions.Item label={intl.messages['order.performedDate']}>
            {order?.performedDate}
          </Descriptions.Item>
          <Descriptions.Item label={intl.messages['order.note']} span={2}>
            {order?.note}
          </Descriptions.Item>
          <Descriptions.Item label={intl.messages['order.result']} span={2}>
            {order?.result}
          </Descriptions.Item>
        </Descriptions>

        <Divider />

        {orderId?.length > 0 && (
          <Media
            orderId={orderId}
            readOnly={order?.request?.status !== ServiceRequestStatus.active}
          />
        )}
      </Spin>
    </Drawer>
  );
};

export default OrderInfo;

OrderInfo.propTypes = {
  orderId: PropTypes.string,
  viewing: PropTypes.bool.isRequired,
  setViewing: PropTypes.func.isRequired,
  setReloading: PropTypes.func.isRequired,
};
